import * as React from 'react';
import { DialogTitle } from '@material-ui/core';
import { DialogContent } from '@material-ui/core';
import { DialogActions } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { observer } from 'mobx-react';
import { IObservableObject, IObservableValue, observable } from 'mobx';
import { isValidationErrors, ValidationErrors } from '../../api/restApi';
import { translation } from '../../i18n';
import { Dialog } from '@material-ui/core';
import { QuestionnaireForm } from './QuestionnaireForm';
import { emptyQuestionnaireRequest, QuestionnaireRequest } from './questionnaireTypes';
import { Spinner } from '../../spinner/Spinner';
import { isValidQuestionnaire } from '../../util/validations';
import { createQuestionnaire } from '../assessment/questionnaireApi';

interface Props {
  onClose: () => void;
  onSave: () => void;
  open: boolean;
}

@observer
export default class NewQuestionnaireDialog extends React.Component<Props> {

  @observable private questionnaire: QuestionnaireRequest & IObservableObject = observable(emptyQuestionnaireRequest());
  @observable private validationErrors: ValidationErrors | undefined = undefined;
  private dirtyState: IObservableValue<boolean> = observable.box(false);
  private loading: IObservableValue<boolean> = observable.box(false);

  constructor(props: Props) {
    super(props);
    this.init = this.init.bind(this);
  }

  public render() {
    return (
      <Dialog
        id="newQuestionnaireDialog"
        open={this.props.open}
        onClose={this.props.onClose}
        fullWidth={true}
        maxWidth="md"
        onRendered={this.init}
      >
        <DialogTitle id="form-dialog-title">{translation.t('newQuestionnaireDialog.title')}</DialogTitle>
        {
          this.loading.get() ?
            <Spinner/> :
            <>
              <DialogContent>
                <QuestionnaireForm questionnaire={this.questionnaire} dirtyState={this.dirtyState}
                                   fieldErrors={this.validationErrors ? this.validationErrors.fieldErrors : []}/>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.props.onClose} color="primary">
                  {translation.t('actions.cancel')}
                </Button>
                <Button onClick={() => this.onSaveClicked()} color="primary">
                  {translation.t('actions.save')}
                </Button>
              </DialogActions>
            </>
        }
      </Dialog>)
  }

  private init() {
    this.dirtyState.set(false);
    this.validationErrors = undefined;
    this.questionnaire = observable(emptyQuestionnaireRequest());
  }

  private onSaveClicked() {
    this.validationErrors = isValidQuestionnaire(this.questionnaire);
   if (this.validationErrors === undefined || this.validationErrors.fieldErrors.length === 0) {
      this.loading.set(true);
      createQuestionnaire(this.questionnaire).then(
        data => {
          this.loading.set(false);
          if (isValidationErrors(data)) {
            this.validationErrors = data;
          } else {
            this.validationErrors = undefined;
            this.props.onSave();
          }
        }
      )
   }
  }
}
